const Menu = [
    { 
        path: '/', icon: 'fa fa-th', title: 'Inicio'
    },
    { 
        path: '/establecimientos-cuarentena', icon: 'fa fa-building', title: 'Establecimientos'
    },
    {
      path: "/reportes-importacion-general",
      icon: "fas fa-vial",
      title: "Reportes importación medicamentos",
    },
    {
      path: "/autorizacion-alimento-cuarentena",
      icon: "fas fa-list",
      title: "Autorización de alimentos",
    },
    {
      path: "/Productos-Cuarentena",
      icon: "fa fa-shopping-basket",
      title: "Productos",
    },
  ]
  
  export default Menu;
  